import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Text from '@/storybook/components/Text/Text';
import AILogoGradientIcon from '@/storybook/icons/AILogoGradientIcon';
import type { AIFilterChip } from '../AIFilterChips/AIFilterChips';
import AIFilterContext from '../AIFilterContext/AIFilterContext';
import QuickQuestions from '../QuickQuestions/QuickQuestions';
import { TestIds } from './testIds';
import styles from './ChatWelcomeMessage.module.css';

export interface ChatWelcomeMessageProps {
  globalFilters: ReadonlyArray<AIFilterChip>;
  localFilters: ReadonlyArray<AIFilterChip>;
  questions: ReadonlyArray<string>;
  onQuestionClick: (question: string) => void;
  filterContextDefaultExpanded?: boolean;
}

const ChatWelcomeMessage: FC<ChatWelcomeMessageProps> = ({
  globalFilters,
  localFilters,
  questions,
  onQuestionClick,
  filterContextDefaultExpanded = false,
}) => {
  const { t } = useTranslation();

  return (
    <section className={styles.container} data-testid={TestIds.container}>
      <div className={styles.introIconWrapper}>
        <AILogoGradientIcon className={styles.introIcon} />
      </div>

      <div className={styles.contentColumn}>
        <div className={styles.introContent}>
          <Text as="p" className={styles.introTitle}>
            <Trans
              i18nKey="components.aiChatDrawer.welcomeMessage.line1"
              components={{
                strong: <span className={styles.introTitleEmphasis} />,
              }}
            />
          </Text>

          <Text as="p" className={styles.introDescription}>
            {t('components.aiChatDrawer.welcomeMessage.line2')}
          </Text>
        </div>

        <div className={styles.filterContextSection}>
          <AIFilterContext
            globalFilters={globalFilters}
            localFilters={localFilters}
            defaultExpanded={filterContextDefaultExpanded}
          />
        </div>
        <div className={styles.quickQuestionsSection}>
          <QuickQuestions questions={questions} onQuestionClick={onQuestionClick} />
        </div>
      </div>
    </section>
  );
};

export default ChatWelcomeMessage;
